/* NIKHAAR — collection & search results: filters, sorting and "Load more" without page reloads. */
(() => {
  const { debounce, parseHTML, closeDialog } = window.NK;

  class FacetFilters extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.cache = new Map();
      this.form = this.querySelector('[data-facet-form]');
      this.sortSelect = this.querySelector('[data-sort-select]');
      const onPriceInput = debounce(() => this.applyForm(), 500);

      this.form?.addEventListener('change', (event) => {
        if (event.target.type === 'number') onPriceInput();
        else this.applyForm();
      });
      this.form?.addEventListener('submit', (event) => {
        event.preventDefault();
        this.applyForm();
      });

      this.sortSelect?.addEventListener('change', () => {
        const hidden = this.form?.querySelector('[data-sort-input]');
        if (hidden) hidden.value = this.sortSelect.value;
        this.applyForm();
      });
      this.querySelector('[data-sort-form]')?.addEventListener('submit', (event) => {
        event.preventDefault();
        this.applyForm();
      });

      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-facet-link]');
        if (link) {
          event.preventDefault();
          this.renderUrl(link.href);
          return;
        }
        const apply = event.target.closest('[data-facet-apply]');
        if (apply) {
          event.preventDefault();
          this.applyForm();
          closeDialog(apply.closest('dialog'));
          return;
        }
        const loadMore = event.target.closest('[data-load-more]');
        if (loadMore) {
          event.preventDefault();
          this.loadMore(loadMore);
        }
      });
    }

    buildParams() {
      if (!this.form) {
        const params = new URLSearchParams(window.location.search);
        params.delete('page');
        if (this.sortSelect) params.set('sort_by', this.sortSelect.value);
        return params;
      }
      const params = new URLSearchParams();
      for (const [key, value] of new FormData(this.form)) {
        if (value !== '') params.append(key, value);
      }
      if (this.sortSelect) params.set('sort_by', this.sortSelect.value);
      return params;
    }

    applyForm() {
      this.render(window.location.pathname, this.buildParams().toString());
    }

    renderUrl(href) {
      const url = new URL(href, window.location.origin);
      url.searchParams.delete('section_id');
      this.render(url.pathname, url.searchParams.toString());
    }

    async render(pathname, query) {
      const fetchUrl = `${pathname}?section_id=${this.sectionId}${query ? `&${query}` : ''}`;
      this.classList.add('is-loading');
      try {
        let html = this.cache.get(fetchUrl);
        if (!html) {
          const response = await fetch(fetchUrl);
          if (!response.ok) throw new Error(response.status);
          html = await response.text();
          this.cache.set(fetchUrl, html);
        }
        this.swap(parseHTML(html));
        window.history.replaceState({}, '', `${pathname}${query ? `?${query}` : ''}`);
      } catch (error) {
        window.location.href = `${pathname}${query ? `?${query}` : ''}`;
      } finally {
        this.classList.remove('is-loading');
      }
    }

    swap(doc) {
      [`ResultsGrid-${this.sectionId}`, `ResultsCount-${this.sectionId}`, `ActiveFacets-${this.sectionId}`].forEach((id) => {
        const current = document.getElementById(id);
        const next = doc.getElementById(id);
        if (current && next) current.innerHTML = next.innerHTML;
      });

      const nextForm = doc.getElementById(`FacetForm-${this.sectionId}`);
      if (!nextForm || !this.form) return;
      this.form.querySelectorAll('[data-facet-group]').forEach((group) => {
        const active = document.activeElement;
        if (group.contains(active) && active.type === 'number') return;
        const nextGroup = nextForm.querySelector(`[data-facet-group="${CSS.escape(group.dataset.facetGroup)}"]`);
        if (!nextGroup) return;
        const focusedId = group.contains(active) ? active.id : null;
        group.querySelector('summary').innerHTML = nextGroup.querySelector('summary').innerHTML;
        group.querySelector('.facet__body').innerHTML = nextGroup.querySelector('.facet__body').innerHTML;
        if (focusedId) document.getElementById(focusedId)?.focus();
      });
    }

    async loadMore(button) {
      button.classList.add('is-loading');
      button.setAttribute('aria-disabled', 'true');
      const url = new URL(button.href, window.location.origin);
      url.searchParams.set('section_id', this.sectionId);
      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(response.status);
        const doc = parseHTML(await response.text());
        const grid = document.getElementById(`ProductGrid-${this.sectionId}`);
        const nextGrid = doc.getElementById(`ProductGrid-${this.sectionId}`);
        const items = nextGrid ? [...nextGrid.children] : [];
        grid.append(...items);

        const pagination = document.getElementById(`Pagination-${this.sectionId}`);
        const nextPagination = doc.getElementById(`Pagination-${this.sectionId}`);
        if (pagination && nextPagination) pagination.replaceWith(nextPagination);
        else pagination?.remove();

        items[0]?.querySelector('.product-card__link, a')?.focus({ preventScroll: true });
      } catch (error) {
        window.location.href = button.href;
      }
    }
  }
  customElements.define('facet-filters', FacetFilters);
})();
